import type { FC } from "react";
import { Ban, Check, Loader2, RotateCw } from "lucide-react";

interface ToolStatusIconProps {
  status?: { type: string; reason?: string };
  isError?: boolean;
}

export const ToolStatusIcon: FC<ToolStatusIconProps> = ({ status, isError }) => {
  if (status?.type === "running") {
    return <Loader2 className="size-3.5 text-purple-600 animate-spin" />;
  }
  if (status?.type === "incomplete" && status.reason === "cancelled") {
    return <Ban className="size-3.5 text-purple-600" />;
  }
  if (isError) {
    return <RotateCw className="size-3.5 text-purple-600" />;
  }
  return <Check className="size-3.5 text-purple-600" />;
};
